import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get user settings.
*/
export const getUserSettings = async (loginHint?: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/user/getusersettings`;
    return await axios.get(url);
}

/**
* Create user settings.
*/
export const createUserSettings = async (userDataEntity: any): Promise<any> => {
    let url = `${baseAxiosUrl}/api/user/createusersettings`;
    return await axios.post(url, userDataEntity);
}

/**
* Update user settings.
*/
export const updateUserSettings = async (userDataEntity: any): Promise<any> => {
    let url = `${baseAxiosUrl}/api/user/updateusersettings`;
    return await axios.post(url, userDataEntity);
}

/**
* Update user last selected view.
*/
export const updateLastSelectedView = async (lastSelectedView: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/user/updatelastselectedview?lastSelectedView=${lastSelectedView}`;
    return await axios.post(url);
}

/**
* Update user selected language.
*/
export const updateSelectedLanguage = async (language: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/user/updatelanguage?language=${language}`;
    return await axios.post(url);
}

/**
* Get current user Id.
*/
export const getCurrentUserEmail  = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/user/getcurrentuseremail`;
    return await axios.get(url);
}